import React, { useState, useEffect } from 'react';
import { IoMdEye } from 'react-icons/io';
import { MdDelete } from "react-icons/md";
import { Button, Pagination } from '@mui/material';
import { json, useNavigate } from 'react-router-dom';
import { useMyContext } from '../../../context/MyContext';
import Sidebar from '../../../component/b2b/sideBar/b2bSideBar';
import NavBar from '../../../component/b2b/navBar/b2bNavBar';
import PaginationItem from '@mui/material/PaginationItem';
import '../../../css/custom-scrollbar.css';
import { LuWarehouse } from "react-icons/lu";
import axios from 'axios';
import Swal from 'sweetalert2';
import { Base_Url, deletewarehouse, b2bWarehouseList } from '../../../config/config';
import B2bViewWarehouse from '../../../component/b2b/models/viewWarehouseModel';

const AllWarehouses = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const { isDarkMode } = useMyContext();
  const [isPopupOpen,setIsPopupOpen] = useState(false);
  const { isToggleSidebar } = useMyContext();
  const [warehouses,setWarehouses] = useState([]);
  const [currentPage,setCurrentPage] = useState(1);
  const [selectedWarehouse,setSelectedWarehouse] = useState(null);
   const [loadingWarehouseId,setloadingWarehouseId] = useState(null);
  const itemsPerPage = 8;
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    fetchWarehouses();
  }, [page, limit]);

  const fetchWarehouses = async () => {
    const token = localStorage.getItem('token');
    const cusid = localStorage.getItem('cus_id');
    try {
      const pageNumber = Number(page) || 1;
      const limitNumber = Number(limit) || 10;
      const urlWarehouse = `${Base_Url}${b2bWarehouseList}?page=${pageNumber}&limit=${limitNumber}`
      const response = await fetch(urlWarehouse, {
        method: 'GET',
        headers: {
          'token': token,
          'cus_id': cusid,
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      if (result.status === "SUCCESS" && Array.isArray(result.data)) {
        setWarehouses(result.data);
        setTotalOrders(result.pagination.totalItems || 0);
      } else {
        console.error('Unexpected response format:', result);
      }
    } catch (error) {
      console.error('Error fetching warehouse data:', error);
    }
  };

  const handlePaginationChange = (event, value) => {
    setPage(value);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = warehouses.slice(indexOfFirstItem, indexOfLastItem);

  const handleViewClick = (warehouse) => {
    setSelectedWarehouse(warehouse);
    setIsPopupOpen(true);
  };

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  const handleNavigation = () => {
    navigate('/dashboard');
  };

  const handleDelete = async (id) => {
  setloadingWarehouseId(id);

  Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this deletion!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then(async (result) => {
    if (result.isConfirmed) {
      const urldelete = Base_Url + deletewarehouse; 
      try {
        const token = localStorage.getItem('token');
        const cusid = localStorage.getItem('cus_id');
        const data = { warehouseId: id };

        const response = await axios.post(urldelete, data, {
          headers: {
            token,
            cus_id: cusid,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
        });

        if (response.data.status === "SUCCESS") {
          setWarehouses((prevWarehouses) =>
            prevWarehouses.filter((warehouse) => warehouse.id !== id)
          );
          setTotalOrders((prev) => prev - 1);

          Swal.fire(
            'Deleted!',
            response.data.message || 'Warehouse has been deleted successfully.',
            'success'
          );
        } else {
          Swal.fire(
            'Error!',
            'Unexpected response format: ' + response.data.message,
            'error'
          );
        }
      } catch (error) {
        Swal.fire(
          'Error!',
          'Error deleting warehouse: ' + error.message,
          'error'
        );
      } finally {
        setloadingWarehouseId(null);
      }
    } else {
      setloadingWarehouseId(null);
    }
  });
};


  return (
    <>
      <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-white'}`}>
        <div className="z-10">
          <NavBar />
        </div>

        <div className="flex flex-1 overflow-hidden">
          {isToggleSidebar && (
            <div className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-black dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
              style={
                window.innerWidth < 768
                  ? { top: "113px", height: "calc(100vh - 115px)", overflowY: 'auto' }
                  : {}
              }>
              <Sidebar />
            </div>
          )}

          <div className={`flex flex-col overflow-hidden  w-full rounded-md border p-2.5 ${isDarkMode ? 'bg-black border-white/20 text-white' : 'bg-gray-100 border-black/15'}`}>

            <button
            //  onClick={handleNavigation}
              className={`text-xs font-bold mb-2 flex-shrink-0 border px-3 py-1.5 rounded flex items-center justify-center transition-colors
                ${isDarkMode
                  ? 'bg-white text-black border-white hover:bg-gray-200'
                  : 'bg-gray-500 text-white border-gray-700 '}`}>
              <LuWarehouse className="mr-1.5" size={14} />
              All Warehouses
            </button>

            <div className="flex-1 overflow-hidden border rounded-md" style={{ borderColor: isDarkMode ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.15)' }}>
              <div className="h-full overflow-y-auto custom-scrollbar overflow-x-auto">
                <table className="min-w-full table-auto">
                  <thead className={`sticky top-0 text-[10px] uppercase tracking-wide ${isDarkMode ? 'bg-white text-black' : 'bg-slate-400 text-gray-700'}`}>
                    <tr>
                      <th className='p-1.5 text-left font-semibold'>ID</th>
                      <th className='p-1.5 text-left font-semibold'>Name</th>
                      <th className='p-1.5 text-left font-semibold'>Contact Person</th>
                      <th className='p-1.5 text-left font-semibold'>Phone</th>
                      <th className='p-1.5 text-left font-semibold'>City</th>
                      <th className='p-1.5 text-left font-semibold'>State</th>
                      <th className='p-1.5 text-left font-semibold'>Country</th>
                      <th className='p-1.5 text-center font-semibold'>Action</th>
                    </tr>
                  </thead>
                  <tbody className={`divide-y ${isDarkMode ? 'divide-white/10' : 'divide-black/10'}`}>
                    {warehouses.map((warehouse, index) => (
                      <tr
                        key={warehouse.id}
                        className={`transition-colors duration-150 ${isDarkMode ? 'hover:bg-white/10' : 'hover:bg-black/5'} ${
                          index % 2 === 0
                            ? (isDarkMode ? 'bg-black' : 'bg-white')
                            : (isDarkMode ? 'bg-white/5' : 'bg-black/[0.03]')
                        }`}
                      >
                        <td className='p-1.5 text-[11px] font-medium'>
                          {warehouse.warehouse_id}
                        </td>
                        <td className='p-1.5 text-[11px] font-medium'>{warehouse.name}</td>
                        <td className='p-1.5 text-[11px] font-medium'>{warehouse.contact_person}</td>
                        {/* <td className='p-1.5 text-[11px] font-medium'>{warehouse.email}</td> */}
                        <td className='p-1.5 text-[11px] font-mono'>{warehouse.phone_number}</td>
                        <td className='p-1.5 text-[11px] font-medium'>{warehouse.city}</td>
                        <td className='p-1.5 text-[11px] font-medium'>{warehouse.state}</td>
                        <td className='p-1.5 text-[11px] font-medium'>{warehouse.country}</td>
                        <td className='p-1.5'>
                          <div className='flex items-center gap-1'>
                            <Button
                              onClick={() => handleViewClick(warehouse)}
                              variant="outlined"
                              size="small"
                              className="min-w-0 p-1 rounded shadow-none"
                              style={{
                                borderColor: isDarkMode ? '#fff' : '#000',
                                color: isDarkMode ? '#fff' : '#000',
                                backgroundColor: 'transparent',
                              }}
                            >
                              <IoMdEye color='blue' className="text-xs" />
                            </Button>

                            <Button
                              onClick={() => handleDelete(warehouse.id)}
                              variant="outlined"
                              size="small"
                              disabled={loadingWarehouseId === warehouse.id}
                              className="min-w-0 p-1 rounded shadow-none"
                              style={{
                                borderColor: isDarkMode ? '#fff' : '#000',
                                color: isDarkMode ? '#fff' : '#000',
                                backgroundColor: 'transparent',
                                opacity: loadingWarehouseId === warehouse.id ? 0.5 : 1,
                              }}
                            >
                              {loadingWarehouseId === warehouse.id ? (
                                <span className="animate-spin text-xs">⏳</span>
                              ) : (
                                <MdDelete color='red' className="text-xs" />
                              )}
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="mt-2 flex-shrink-0 flex flex-col sm:flex-row justify-between items-center gap-2">
              <span className="text-[11px] font-bold">{`Total Warehouse: ${totalOrders}`}</span>
              <select
                id="limit"
                value={limit}
                onChange={handleLimitChange}
                className={`border rounded px-1.5 py-0.5 text-[11px] ${isDarkMode ? 'bg-black text-white border-white/30' : 'bg-white text-black border-black/30'}`}
              >
                <option value={10}>10</option>
                <option value={15}>15</option>
                {/* <option value={50}>50</option> */}
                <option value={totalOrders}>All</option>
              </select>
              <Pagination
                count={Math.ceil(totalOrders / limit)}
                page={page}
                onChange={handlePaginationChange}
                variant="outlined"
                shape="rounded"
                className="pagination"
                size="small"
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    className="mx-0.5 rounded"
                    style={{
                      color: isDarkMode ? '#fff' : '#000',
                      borderColor: isDarkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                      backgroundColor: item.selected ? (isDarkMode ? '#fff' : '#000') : 'transparent',
                      ...(item.selected ? { color: isDarkMode ? '#000' : '#fff' } : {}),
                    }}
                  />
                )}
              />
            </div>
          </div>
        </div>
        <B2bViewWarehouse isopen={isPopupOpen} onClose={handleClose} warehouse={selectedWarehouse} />
      </div>
    </>
  );
};

export default AllWarehouses;